import React from 'react';
import Icon from '../../../components/AppIcon';

const WhoItsForSection = () => {
  const targetUsers = [
    {
      icon: 'User',
      title: 'Individuals Managing Daily Finances',
      description: 'Perfect for anyone who wants to stay on top of their everyday spending and income'
    },
    {
      icon: 'CreditCard',
      title: 'People with Multiple Accounts',
      description: 'Manage checking, savings, credit cards, and payment obligations all in one place'
    },
    {
      icon: 'BarChart3',
      title: 'Users Who Want Clarity',
      description: 'Get clear insights without complicated spreadsheets or confusing financial jargon'
    },
    {
      icon: 'Heart',
      title: 'Anyone Seeking Financial Peace',
      description: 'Experience a smarter, calmer way to budget and make confident money decisions'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-gradient-to-br from-accent/5 via-background to-primary/5">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-secondary mb-3 md:mb-4">
            Built For Real People
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Rovyn Budget is designed for everyday users who want control over their finances without the complexity
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 lg:gap-8 max-w-5xl mx-auto">
          {targetUsers?.map((user, index) => (
            <div
              key={index}
              className="bg-card rounded-xl md:rounded-2xl shadow-elevation-2 hover:shadow-elevation-3 transition-smooth p-5 md:p-6 lg:p-8"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-xl flex items-center justify-center">
                  <Icon name={user?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-card-foreground mb-2">
                    {user?.title}
                  </h3>
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {user?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsForSection;